import { Injectable } from '@angular/core';
import { DataService } from '../../data.service';
import { ReportViewer } from 'src/app/model/report-viewer';
import { ClientSearch } from 'src/app/model/client-search';
import { InvoiceNumberBookPoint } from 'src/app/model/invoice-number-book-point';
import { BillingInvoice } from 'src/app/model/billing/billing-invoice';
import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
import { BillingInvoiceCreateResponse } from 'src/app/model/billing/billing-invoice-create-response';
import { BillingInvoiceEditInfo } from '../../../model/billing/billing-invoice-edit-info';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceManualCreditService {

  constructor( private dataService: DataService ) { }

  private readonly getBillingInvoiceReportEndPoint: string =
          '/billingInvoiceManualCredit/getBillingInvoiceReport/';

  private readonly getBillingInvoiceEditInfoEndPoint: string =
          '/billingInvoiceManualCredit/getBillingInvoiceWithItemEditInfo/';

  private readonly billingInvoiceCreateEndPoint: string =
          '/billingInvoiceManualCredit/billingInvoiceCreate/';

  async getBillingInvoiceWithItemEditInfo( sectorId: number, billingInvoiceId?: number ):
       Promise<{ Items: BillingInvoiceItemEditInfo[], BillingInvoiceEditInfo: BillingInvoiceEditInfo }> {
    const params = { sectorId, billingInvoiceId };
    return await this.dataService
      .get<{ Items: BillingInvoiceItemEditInfo[], BillingInvoiceEditInfo: BillingInvoiceEditInfo }>
        (this.getBillingInvoiceEditInfoEndPoint, params)
      .toPromise();
  }

  async getBillingInvoiceReport( billingInvoiceId: number ): Promise<ReportViewer> {

    const params = { billingInvoiceId };
    return await this.dataService
      .get<ReportViewer>(this.getBillingInvoiceReportEndPoint, params)
      .toPromise();
  }

  async billingInvoiceCreate(clientSearch: ClientSearch,
    invoiceNumberBookPoint: InvoiceNumberBookPoint,
    billingInvoice: BillingInvoice,
    items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

    const params = {
      IsRejected: billingInvoice.IsRejected,
      Description:  billingInvoice.Description,
      BillingInvoicePeriod: billingInvoice.BillingInvoicePeriod,
      InvoiceDate: billingInvoice.InvoiceDate,
      InvoiceExpiredDate: billingInvoice.InvoiceExpiredDate,
      Amount: billingInvoice.Amount,
      InvoiceFrom: billingInvoice.InvoiceFrom,
      InvoiceTo: billingInvoice.InvoiceTo,
      InvoiceLabelType:  billingInvoice.InvoiceLabelType,
      TaxpayerType:  billingInvoice.TaxpayerType,
      InvoicePoint: billingInvoice.InvoicePoint,
      ClientSearch: clientSearch,
      InvoiceTaxes: billingInvoice.InvoiceTaxes,
      InvoiceNumberBookPoint: invoiceNumberBookPoint,
      OriginalBillingInvoiceManualId: billingInvoice.OriginalBillingInvoiceManualId,
      OriginalBillingInvoiceId: billingInvoice.OriginalBillingInvoiceId,
      OriginalBillingInvoiceDate: billingInvoice.OriginalBillingInvoiceDate,
      OriginalAmount: billingInvoice.OriginalAmount,
      OriginalCompanyId: billingInvoice.OriginalCompanyId,
      Items: items,
    };

  return await this.dataService.post<BillingInvoiceCreateResponse>(this.billingInvoiceCreateEndPoint, params)
    .toPromise();
  }
}
